import React from 'react';
import WarningBanner from '@/components/salesman/WarningBanner';
import BottomNav from '@/components/salesman/BottomNav';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { User, LogOut } from 'lucide-react';
import { useAuth } from '@/lib/AuthContext';

export default function SalesmanAccount() {
  const { user, logout } = useAuth();
  return (
    <div className="min-h-screen bg-background pb-24">
      <WarningBanner />
      <div className="px-4 py-4 max-w-md mx-auto space-y-4">
        <div className="font-heading font-semibold text-lg flex items-center gap-2"><User className="h-5 w-5" />Akun</div>
        <Card>
          <CardContent className="p-5 space-y-3">
            <div>
              <div className="text-xs text-muted-foreground">Nama Lengkap</div>
              <div className="font-medium">{user?.full_name}</div>
            </div>
            <div>
              <div className="text-xs text-muted-foreground">Username</div>
              <div className="font-mono">{user?.username}</div>
            </div>
            <div>
              <div className="text-xs text-muted-foreground">Role</div>
              <div className="capitalize">{user?.role}</div>
            </div>
            {user?.phone && (
              <div>
                <div className="text-xs text-muted-foreground">Telepon</div>
                <div>{user?.phone}</div>
              </div>
            )}
          </CardContent>
        </Card>
        <Button variant="destructive" className="w-full" onClick={logout} data-testid="salesman-logout-account"><LogOut className="h-4 w-4 mr-2" />Keluar</Button>
      </div>
      <BottomNav />
    </div>
  );
}
